// Types.
// -----------------------------------------------------------------------------
export const UI_SIZES = [
    '2xs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
    '10xl'
];
//# sourceMappingURL=theme.types.js.map